import React from 'react';
import { includes } from 'lodash-es';
import {
  Box,
  Flag,
  HStack,
  pickColor,
  Text,
} from 'remodeling-web-mobile-sdk-ui';
import styled from 'styled-components';
import { SearchAddress } from '@remodeling/common';
import TrackingService from '@/services/tracking';

interface SearchZoneCodeResultItemProps {
  item: SearchAddress;
  handleClickAddressItem: (item: SearchAddress) => void;
  handleClose: (id: string) => void;
}

const SearchZoneCodeResultItem = ({
  item,
  handleClickAddressItem,
  handleClose,
}: SearchZoneCodeResultItemProps) => {
  return (
    <Box
      onClick={() => {
        handleClickAddressItem(item);
        handleClose('SearchZoneCodeLayerPopUp');
      }}
      py={20}
      mx={20}
      borderBottom="1px solid"
      borderBottomColor={pickColor('natural_color.gray.100')}
      {...TrackingService.tagGTM('search_zone_code_item')}
    >
      <Text
        variant="subTitle2"
        color={pickColor('accent_color.primary.default')}
        mb="2px"
      >
        [{item.post5No}]
      </Text>
      <Text
        variant="body2"
        color={pickColor('accent_color.primary.default')}
        mb={10}
      >
        {`${
          item.bldgNm && !includes(item.addrRoad, item.bldgNm)
            ? item.addrRoad.slice(0, -1) + ', ' + item.bldgNm + ')'
            : item.addrRoad
        }`}
      </Text>

      <HStack mb="7px" alignment="start">
        <StyledFlag variant="mono" mr="8px">
          도로명
        </StyledFlag>
        <Text
          variant="caption1"
          color={pickColor('natural_color.gray.700')}
          flex="1"
        >
          {item.addrRoad}
        </Text>
      </HStack>
      <HStack alignment="start">
        <StyledFlag variant="mono" mr="8px">
          지번
        </StyledFlag>
        <Text
          variant="caption1"
          color={pickColor('natural_color.gray.700')}
          flex="1"
        >
          {item.addrJibun}
        </Text>
      </HStack>
    </Box>
  );
};

const StyledFlag = styled(Flag)`
  width: 36px;
  text-align: center;
`;

export default SearchZoneCodeResultItem;
